export const SET_SOLICITANTE = "SET_SOLICITANTE";
export const SET_INFORMACOES = "SET_INFORMACOES";
export const SET_ERROR = "SET_ERROR";
export const SET_MUNICIPIOS = "SET_MUNICIPIOS";
export const SET_MUNICIPIOS_CORRESPONDENCIA = "SET_MUNICIPIOS_CORRESPONDENCIA";
export const SET_UFS = "SET_UFS";
export const ACTIVE_CADASTRO = "ACTIVE_CADASTRO";
export const DESACTIVE_CADASTRO = "DESACTIVE_CADASTRO";
export const SET_MODALIDADE_PESCA = "SET_MODALIDADE_PESCA";
export const SET_LOCALIZACAO_PREFERENCIAL_PESCA =
  "SET_LOCALIZACAO_PREFERENCIAL_PESCA";
export const SET_RENDA_MENSAL = "SET_RENDA_MENSAL";
export const SET_FAIXA_ETARIA = "SET_FAIXA_ETARIA";
export const SET_LOCAL_PESCA = "SET_LOCAL_PESCA";
export const SET_MATERIAL_PESCA = "SET_MATERIAL_PESCA";
export const SET_TIPO_ISCA = "SET_TIPO_ISCA";
export const CADASTRAR_SOLICITANTE = "CADASTRAR_SOLICITANTE";
export const CADASTRAR_INFORMACOES_COMPLEMENTARES =
  "CADASTRAR_INFORMACOES_COMPLEMENTARES";
export const SET_DADOS_CARTEIRA = "SET_DADOS_CARTEIRA";
export const SET_PROTOCOLO = "SET_PROTOCOLO";
export const CLEAN_SOLICITANTE = "CLEAN_SOLICITANTE";
export const CLEAN_INFORMACOES = "CLEAN_INFORMACOES";
export const CLEAN_REGISTRO = "CLEAN_REGISTRO";
export const SET_PAGINACAO = "SET_PAGINACAO";
export const SET_LISTA_TODAS_LICENCAS = "SET_LISTA_TODAS_LICENCAS";
export const SET_ERROR_TELA_BUSCA = "SET_ERROR_TELA_BUSCA";
export const SET_DADOS_SOLICITANTE_CONFIRMAR =
  "SET_DADOS_SOLICITANTE_CONFIRMAR";
export const SET_REGISTRO_SOLICITANTE = "SET_REGISTRO_SOLICITANTE";
export const SET_NACIONALIDADE = "SET_NACIONALIDADE";
export const SET_PAISES = "SET_PAISES";
export const CLEAN_PESQUISA = "CLEAN_PESQUISA";
// USUARIO LOGIN
export const START_USUARIO_LOGIN = "START_USUARIO_LOGIN";
export const END_USUARIO_LOGIN = "END_USUARIO_LOGIN";
export const UPDATE_USUARIO_LOGIN = "UPDATE_USUARIO_LOGIN";
// USUARIO LOGOUT
export const START_USUARIO_LOGOUT = "START_USUARIO_LOGOUT";
export const END_USUARIO_LOGOUT = "END_USUARIO_LOGOUT";
export const UPDATE_USUARIO_LOGOUT = "UPDATE_USUARIO_LOGOUT";
// SNACKBAR
export const UPDATE_SNACKBAR = "UPDATE_SNACKBAR";
